export const getCurrentResults = state => state.currentResults;
